<template>
  <audio ref="notification-sound">
    <source src="/audio/notification.ogg" type="audio/ogg" />
    <source src="/audio/notification.mp3" type="audio/mpeg" />
    Your browser does not support the audio element.
  </audio>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      notification: 'app/newNotification'
    })
  },
  watch: {
    notification: {
      deep: true,
      handler (val) {
        this.$refs['notification-sound'].play()
      }
    }
  }
}
</script>
